import { memo } from 'react';

import styles from './Loader.module.scss';
import { LoopSpinner } from './LoopSpinner/LoopSpinner';

/**
 * CategoryWidget 의 내장 default loader.
 *
 * 호스트가 `loader` prop 으로 override 안 한 경우 표시.
 * NOL 디자인 시스템의 LoopSpinner (소스 복사본) 를 중앙 배치.
 */
export const Loader = memo(function DefaultLoader() {
  return (
    // wrapper 가 role=status 를 가져 LoopSpinner 의 delay (300ms 동안 spinner null) 기간에도
    // 스크린리더가 loading 상태를 인지. spinner 가 render 되면 자체 role=status 도 활성됨 (이중이지만 무해).
    <div aria-busy="true" aria-label="카테고리를 불러오는 중" className={styles.loader} role="status">
      <LoopSpinner size="medium" />
    </div>
  );
});
